import React, { useEffect, useRef, useState } from "react";
import DropdownSelect from "./../components/dropdownSelect";
import SelectList from "./components/selectList";
import SelectInfo from "./components/selectInfo";
import { useLocation,useNavigate } from "react-router-dom";
import { Toast } from "antd-mobile";
import close from "@/assets/img/landfi/icon_del.png";

import {
  LevelOptions,
  getApeCate,
  getOtherSelect,
  getConsumableSelect,
  getConsumableFilterParams,
  CONSUMABLE_SERIES_ID,
} from "./../../utils";
import styles from "./styles.module.scss";
import CascaderDropdownSelect from "@/view/landGame/leaseCenter/components/cascaderDropdownSelect";

const LAND_SUB_TAB = {
  LAND: 'land',
  CONSUMABLE: 'consumable',
};

const RentOut = () => {
  const navigate = useNavigate();

  const listRef = useRef(null);
  const infoRef = useRef(null);

  const { state } = useLocation();
  const { type } = state;
  const [selectData, setSelectData] = useState([]);
  const [filterData, setFilterData] = useState({});
  const [apeCate, setApeCate] = useState([]);
  const [seriesId, setSeriesId] = useState('all')
  const [collectionIds, setCollectionIds] = useState('all')
  const [otherOptions, setOtherOptions] = useState([])
  const [consumableOptions, setConsumableOptions] = useState([])
  const [landSubTab, setLandSubTab] = useState(LAND_SUB_TAB.LAND)
  const [consumableFilter, setConsumableFilter] = useState(
    getConsumableFilterParams({ seriesId: CONSUMABLE_SERIES_ID, collectionIds: '' })
  )

  const isLandType = type === 2;
  const isOtherType = type === 3;
  const isConsumableTab = isLandType && landSubTab === LAND_SUB_TAB.CONSUMABLE;
  const listType = isConsumableTab ? 3 : type;

  const getOtherOptions = async () => {
    try {
      const res = await getOtherSelect()
      setOtherOptions(res)
    }catch (e) {
      console.log(e);
    }
  }

  const getConsumableOptions = async () => {
    try {
      const res = await getConsumableSelect()
      setConsumableOptions(res)
    } catch (e) {
      console.log(e);
    }
  }

  useEffect(() => {
    if (type === 3) {
      getOtherOptions()
    } else if (type === 2) {
      getConsumableOptions()
    } else {
      getApeCateOptions();
    }
  }, []);

  const selectChange = (data) => {
    setSelectData(data);
  };
  const levelChange = (data) => {
    setFilterData(data);
  };
  const refresh = () => {
    setSelectData([]);
    listRef.current?.refresh();
    infoRef.current?.refresh();
  };

  const handleLandSubTabChange = (tab) => {
    if (tab === landSubTab) return;
    setLandSubTab(tab);
    setSelectData([]);
    setFilterData({});
    setConsumableFilter(getConsumableFilterParams({ seriesId: CONSUMABLE_SERIES_ID, collectionIds: '' }));
    listRef.current?.refresh();
    infoRef.current?.refresh();
  };

  const getApeCateOptions = async () => {
    try {
      const res = await getApeCate();
      setApeCate(res)
    } catch (error) {
      Toast.show(error);
    }
  };

  const hasSubTabs = isLandType;

  return (
    <div className={styles.land_rent_detail_out}>
       <img
          className={styles.close}
          src={close}
          alt=""
          onClick={() => {
            navigate(-1);
          }}
        />
      <div className={`${styles.left} ${hasSubTabs ? styles.left_with_sub_tabs : ''}`}>
        {hasSubTabs ? (
          <div className={styles.sub_tabs}>
            <div
              className={`${styles.sub_tab} ${landSubTab === LAND_SUB_TAB.LAND ? styles.active : ''}`}
              onClick={() => handleLandSubTabChange(LAND_SUB_TAB.LAND)}
            >
              土地
            </div>
            <div
              className={`${styles.sub_tab} ${landSubTab === LAND_SUB_TAB.CONSUMABLE ? styles.active : ''}`}
              onClick={() => handleLandSubTabChange(LAND_SUB_TAB.CONSUMABLE)}
            >
              土地耗材
            </div>
          </div>
        ) : null}
        <div className={styles.select_box}>
          {isOtherType ? (
            <CascaderDropdownSelect
              title="系列"
              options={otherOptions}
              onChange={(item, subItem) => {
                if(item) {
                  setSeriesId(item?.value)
                  if(subItem){
                    setCollectionIds(subItem.value)
                  }
                }
              }}/>
          ) : isConsumableTab ? (
            <DropdownSelect
              title="分类"
              options={consumableOptions}
              onChange={(item) => setConsumableFilter(getConsumableFilterParams(item))}
            />
          ) : (
            <DropdownSelect
              title="等级"
              options={type === 1 ? apeCate : LevelOptions}
              onChange={levelChange}
            />
          )}
        </div>
        <div className={styles.list_box}>
          <SelectList
            key={isConsumableTab ? 'consumable' : `type-${type}`}
            type={isConsumableTab ? 3 : type}
            ref={listRef}
            filterData={filterData}
            seriesId={isConsumableTab ? consumableFilter.seriesId : (isOtherType ? seriesId : undefined)}
            collectionIds={isConsumableTab ? consumableFilter.collectionIds : (isOtherType ? collectionIds : undefined)}
            isConsumable={isConsumableTab}
            showQuantity={isConsumableTab}
            singleSelect={isConsumableTab}
            onChange={selectChange}
          />
        </div>
      </div>
      <div className={styles.right}>
        <SelectInfo
          ref={infoRef}
          title="等级"
          type={listType}
          publishType={type}
          isConsumable={isConsumableTab}
          consumableFilter={consumableFilter}
          selectData={selectData}
          refresh={refresh}
        />
      </div>
    </div>
  );
};

export default RentOut;
